var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReleaseNotesDisplay',{attrs:{"type-item-class":"pa-5","release-notes":_vm.releaseNotes}})
}
var staticRenderFns = []

export { render, staticRenderFns }